import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWrench } from "@fortawesome/free-solid-svg-icons";
// import NavBar from "../components/common/navBar";
// import Logo from "../components/common/logo";
import INFO from "../data/user";
import "./styles/maintenance.css";

const MaintenancePage = () => {
  useEffect(() => {
    document.title = `Maintenance | ${INFO.main.title}`;
  }, []);

  return (
    <React.Fragment>
      {/* <div className="maintenance-page page-content"> */}
      <div className="maintenance-page">
        {/* <NavBar /> */}
        <div className="content-wrapper">
          {/* <div className="maintenance-logo-container">
            <div className="projects-logo">
              <Logo width={46} />
            </div>
          </div> */}
          <div className="maintenance-container">
            <div className="maintenance-message">
              <div className="maintenance-title">
                Under Maintenance <FontAwesomeIcon icon={faWrench} />
              </div>
              <div className="maintenance-message-text">
                We are currently performing scheduled maintenance on our website.
                <br />
                Thank you for your patience!
              </div>
              <div className="maintenance-contact">
                {/* For urgent matters, please contact the administrator. */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MaintenancePage;